import paintings1 from './level1';
import paintings2 from './level2';
import paintings3 from './level3';
import paintings4 from './level4';
import paintings5 from './level5';
import paintings6 from './level6';

export const paintings = [
  paintings1,
  paintings2,
  paintings3,
  paintings4,
  paintings5,
  paintings6,
];
